export default __webpack_public_path__ + "9e338b6c4a24c9e7d85950b72a33dc0c.svg";